import React, { Component } from 'react';
import moment from 'moment';
import DateTimeField from 'react-bootstrap-datetimepicker';
import ERegistryNumbers from '../components/ERegistryNumbers';
import MaskedInput from 'react-maskedinput';
import Select from 'react-select';
import Spinner from 'react-spinner';
import { Message } from '../locale/Message';
import { numeric } from '../utils/Helper';
import { Button, Modal } from 'react-bootstrap';
import Scroll from 'react-scroll';
import {
  emailRegex,
  dateRegex,
  realNumRegex,
  paymentNumRegex
} from '../utils/Regexes';
import BankServices from '../services/BankServices';
import '../style/Spinner.scss';
import '../style/ERegistry.scss';
import '../css/bootstrap.min.css';
import '../css/index.css';
import '../css/react-bootstrap-table-all.min.css';
import '../css/react-datetime.css';
import '../css/header.css';
import 'react-select/dist/react-select.min.css';
import { ERegistryModal } from '../components/shared/ERegistryModal';
import LangSelect from '../components/shared/LangSelect';
import { RecognitionModal } from '../components/RecognitionModal/RecognitionModal';
import {
  SOURCE,
  lang,
  setLangItem,
  REACT_APP_RECAPTCHA_SITE_KEY
} from '../services/constants';
import http, { formDataHttp } from '../services/http';
import editIcon from '../img/edit.svg';
import doneIcon from '../img/done.svg';
import infoIcon from '../img/info.svg';
import logo from '../img/KcellLogo.svg';

const toFloat = v => {
  const s = String(v ?? '').replace(',', '.');
  return parseFloat(s);
};

const permittedStatuses = [
  'AVAILABLE_FOR_PAYMENT',
  'ACCOUNT_DOES_NOT_BELONG_TO_CUSTOMER',
  'INVOICE_DOES_NOT_BELONG_TO_CUSTOMER'
];

const confirmationStatuses = [
  'ACCOUNT_DOES_NOT_BELONG_TO_CUSTOMER',
  'INVOICE_DOES_NOT_BELONG_TO_CUSTOMER'
];

const EREGISTRY_INSTRUCTION_LINKS = {
  ru:
    'https://static.kcell.kz/files/kcell/docs/eregistry_instruction_ru_new.pdf',
  kk:
    'https://static.kcell.kz/files/kcell/docs/eregistry_instruction_kk_new.pdf',
  en:
    'https://static.kcell.kz/files/kcell/docs/eregistry_instruction_ru_new.pdf'
};

const getEregistryInstructionLink = currentLang =>
  EREGISTRY_INSTRUCTION_LINKS[currentLang] ||
  EREGISTRY_INSTRUCTION_LINKS.ru;

const EREGISTRY_VIDEO_LINKS = {
  ru:
    'https://static.kcell.kz/files/kcell/docs/eregistry_video_ru.mp4',
  kk:
    'https://static.kcell.kz/files/kcell/docs/eregistry_video_kk.mp4',
  en:
    'https://static.kcell.kz/files/kcell/docs/eregistry_video_ru.mp4'
};

const getEregistryVideoLink = currentLang =>
  EREGISTRY_VIDEO_LINKS[currentLang] || EREGISTRY_VIDEO_LINKS.ru;

const IS_SAP_HANA_MODAL_ENABLED = false;
class ERegistry extends Component {
  constructor(props) {
    moment.locale(lang);
    super(props);

    this.state = {
      recognitionData: {
        bin: '',
        companyName: '',
        kcellAccount: '',
        paymentDate: '',
        paymentNumber: '',
        paymentSum: ''
      },
      formData: {
        bin: {
          value: '',
          validate: value => {
            if (!value || numeric(value).length < 12) {
              return Message[lang].require_bin;
            }
            if (numeric(value) === '980540002879') {
              return Message[lang].entered_bin_belongs_to_kcell;
            }
            return null;
          },
          error: null,
          isEdit: false
        },
        file: {
          value: null,
          fileName: '',
          validate: value =>
            !value ? Message[lang].require_payment_order_scan : null,
          error: null
        },
        name: {
          value: '',
          validate: value =>
            !value || value === ''
              ? Message[lang].require_company_name
              : null,
          error: null,
          isEdit: false
        },
        phone: {
          value: '',
          validate: value =>
            !value || numeric(value).length < 11
              ? Message[lang].require_contact_phone
              : null,
          error: null
        },
        email: {
          value: '',
          validate: value =>
            !value || value === '' || !value.match(emailRegex)
              ? Message[lang].require_email
              : null,
          error: null
        },
        paymentDate: {
          value: null,
          validate: value =>
            !value || value === '' || !value.match(dateRegex)
              ? Message[lang].require_payment_date
              : null,
          error: null,
          isEdit: false
        },
        registry: {
          value: [],
          validate: value =>
            !value || !value[0]
              ? Message[lang].require_account_and_amount
              : null,
          error: null
        },
        paymentNumber: {
          value: '',
          validate: value =>
            !value || value === ''
              ? Message[lang].require_payment_order_number
              : null,
          error: null,
          isEdit: false
        },
        paymentSum: {
          value: '',
          validate: value => {
            const registry = this.state.formData.registry;
            const sum = toFloat(String(value));
            return !value || value === ''
              ? Message[lang].require_payment_amount
              : registry.validate(registry.value) ||
                registry.value
                  .map(i => toFloat(i.amount))
                  .reduce((l, r) => l + r, 0)
                  .toFixed(2) != sum
              ? Message[lang].amount_do_not_much
              : null;
          },
          error: null,
          isEdit: false,
          isModalError: false
        },
        destinationBankAccount: {
          value: null,
          validate: value =>
            !value || value === ''
              ? Message[lang].require_payment_account
              : null,
          error: null,
          isEdit: false
        }
      },
      paymentDocument: {
        isLoading: false,
        status: '',
        tries: 3,
        isModalOpen: false
      },
      bankAccounts: [],
      token: null,
      captchaToken: null,
      captchaError: null,
      registryCheckPassed: false,
      showRegistryConfirmationModal: false,
      openCaptchaAfterConfirmation: false,
      requiresRegistryConfirmation: false,
      showSapHanaMigrationModal: IS_SAP_HANA_MODAL_ENABLED,
      showNewErpRegistryModal: !IS_SAP_HANA_MODAL_ENABLED,

      recognition: {
        id: '',
        isModalOpen: false
      }
    };
    this.recaptchaWidgetId = undefined;
  }

  onRegistryChange(data, error = null) {
    this.setState(prev => ({
      formData: {
        ...prev.formData,
        registry: {
          ...prev.formData.registry,
          value: data,
          error: error
        }
      },
      registryCheckPassed: false,
      requiresRegistryConfirmation: false,
      showRegistryConfirmationModal: false,
      openCaptchaAfterConfirmation: false,
      captchaToken: null,
      captchaError: null
    }));
  }

  setFormData(newFormData) {
    this.setState({
      formData: {
        ...this.state.formData,
        ...newFormData
      }
    });
  }

  componentDidMount() {
    BankServices.getBankAccounts()
      .then(responce => {
        this.setState({
          bankAccounts: responce.data.map(d => {
            return {
              id: d.id,
              account: d.account,
              label: `${d.bankName}\t${d.account}`
            };
          })
        });
      })
      .catch(() => {
        // DEV ONLY:
        // локальный мок для тестирования UI без доступа к BankServices
        // ❗ НЕ ИСПОЛЬЗОВАТЬ В STAGE / PROD
        /*
  if (process.env.NODE_ENV === 'development') {
    this.setState({
      bankAccounts: [
        {
          id: 1,
          account: 'KZ00TEST000000000000',
          label: 'Kcell\tKZ00TEST000000000000'
        }
      ]
    });
    return;
  }
  */

        this.setState({
          error: Message[lang].service_not_available
        });
      });

    window.onERegistryRecaptchaLoad = () => {
      this.renderRecaptcha();
    };

    if (!document.getElementById('google-recaptcha-script')) {
      const script = document.createElement('script');

      script.id = 'google-recaptcha-script';
      script.src =
        'https://www.google.com/recaptcha/api.js?onload=onERegistryRecaptchaLoad&render=explicit';
      script.async = true;
      script.defer = true;

      document.body.appendChild(script);
    } else {
      this.renderRecaptcha();
    }
  }

  renderRecaptcha = () => {
    const container = document.getElementById('recaptcha-container');
    const recaptchaApi = window.grecaptcha || null;
    if (
      !container ||
      !recaptchaApi ||
      typeof recaptchaApi.render !== 'function' ||
      this.recaptchaWidgetId !== undefined
    ) {
      return;
    }

    const siteKey = REACT_APP_RECAPTCHA_SITE_KEY;

    if (!siteKey) {
      return;
    }

    this.recaptchaWidgetId = recaptchaApi.render(container, {
      sitekey: siteKey,
      callback: token => {
        this.setState({
          captchaToken: token,
          captchaError: null,
          error: null
        });
      },
      'expired-callback': () => {
        this.setState({
          captchaToken: null
        });
      },
      'error-callback': () => {
        this.setState({
          captchaToken: null,
          captchaError: 'Ошибка reCAPTCHA'
        });
      }
    });
  };

  validate(lang) {
    const { formData } = this.state;
    const amountError = formData.paymentSum.validate(
      formData.paymentSum.value
    );
    if (amountError === Message[lang].amount_do_not_much) {
      this.setState(prev => ({
        formData: {
          ...prev.formData,
          paymentSum: {
            ...prev.formData.paymentSum,
            isModalError: true
          }
        }
      }));
    }
    Object.keys(formData)
      .filter(key => formData[key].validate)
      .forEach(
        key =>
          (formData[key].error = formData[key].validate(
            formData[key].value
          ))
      );
    const error =
      Object.keys(formData).filter(key => formData[key].error)
        .length > 0;
    if (error) {
      Scroll.animateScroll.scrollToTop();
    }
    return error && Message[lang].require_all_fiels;
  }

  getFormData = () => {
    const {
      bin,
      name,
      phone,
      email,
      paymentDate,
      destinationBankAccount,
      registry,
      paymentNumber,
      paymentSum,
      file
    } = this.state.formData;

    const recognition = this.checkRecognitionChanges(
      this.state.recognitionData,
      {
        bin: bin.value?.split(' ')?.join(''),
        companyName: name.value,
        kcellAccount:
          this.state.bankAccounts.find(
            acc => acc.id === destinationBankAccount.value
          )?.account ?? null,
        paymentDate: paymentDate.value,
        paymentNumber: paymentNumber.value,
        paymentSum: Number(paymentSum.value)
      }
    );

    const registries = [];

    for (let i = 0; i < registry.value.length; i++) {
      const row = registry.value[i] || {};

      const msisdn = numeric(row.msisdn);
      const account = String(row.account ?? '').trim();
      const invoice = String(row.invoice ?? '').trim();
      const amount = toFloat(row.amount);

      // одно из полей должно быть заполнено (msisdn/account/invoice)
      // добавляем ровно одно поле + amount
      if (msisdn && msisdn.length >= 11) {
        registries.push({ msisdn, amount });
      } else if (account) {
        registries.push({ account, amount });
      } else if (invoice) {
        registries.push({ invoice, amount });
      }
    }

    const formData = new FormData();

    const form = {
      bin: numeric(bin.value),
      companyName: name.value,
      creationDate: moment()
        .utcOffset('+06:00')
        .format('YYYY-MM-DD HH:mm:ss.SSS')
        .toString(),
      phone: numeric(phone.value),
      email: email.value,
      kcellAccount: { id: destinationBankAccount.value },
      paymentNumber: paymentNumber.value,
      paymentSum: toFloat(String(paymentSum.value)),
      paymentDate: moment(paymentDate.value, 'YYYY-MM-DD')
        .format('YYYY-MM-DD HH:mm:ss.SSS')
        .toString(),
      registries,
      source: SOURCE,
      recognition
    };

    formData.append('captcha', this.state.captchaToken);
    formData.append('application', JSON.stringify(form));
    formData.append('files', file.value);

    return formData;
  };

  checkRecognitionChanges(recognitionData, formData) {
    for (let key in recognitionData) {
      if (
        recognitionData.hasOwnProperty(key) &&
        formData.hasOwnProperty(key)
      ) {
        if (recognitionData[key] !== formData[key]) {
          return false;
        }
      }
    }
    return true;
  }

  sendEregistry = () => {
    this.setState({
      error: null,
      confirmProcessing: true,
      showModal: true,
      modalProcessing: true
    });

    formDataHttp
      .post(`/application`, this.getFormData())
      .then(() => {
        this.setState({
          confirmProcessing: false,
          modalProcessing: false,
          showModal: false,
          completed: true
        });
        Scroll.animateScroll.scrollToTop();
      })
      .catch(error => {
        switch (error.response && error.response.status) {
          case 405:
            error = Message[lang].request_has_been_processed;
            break;
          case 413:
            error = Message[lang].file_is_large;
            break;
          case 422:
            error =
              (error.response &&
                error.response.data &&
                error.response.data.message) ||
              Message[lang].service_not_available;
            break;
          case 409:
            error = Message[lang].already_exists_same_app;
            break;
          default:
            error = Message[lang].service_not_available;
            break;
        }

        const recaptchaApi = window.grecaptcha || null;

        if (
          recaptchaApi &&
          typeof recaptchaApi.reset === 'function' &&
          this.recaptchaWidgetId !== undefined
        ) {
          recaptchaApi.reset(this.recaptchaWidgetId);
        }

        this.setState(
          {
            sendProcessing: false,
            confirmProcessing: false,
            modalProcessing: false,
            showModal: false,
            captchaToken: null,
            captchaError: null,
            registryCheckPassed: false,
            error: error
          },
          () => Scroll.animateScroll.scrollToTop()
        );
      });
  };

  showDialog() {
    this.setState({ showModal: true });
  }

  validateForm() {
    this.setState({ error: null });
    const error = this.validate(lang);

    if (error) {
      this.setState({
        error: error,
        confirmProcessing: false,
        showModal: false,
        modalProcessing: false
      });
    } else {
      this.checkRegistry();
    }
  }
  getTypeValue = r => {
    if (r.msisdn) return { type: 'msisdn', value: numeric(r.msisdn) };
    if (r.account)
      return { type: 'account', value: String(r.account).trim() };
    if (r.invoice)
      return { type: 'invoice', value: String(r.invoice).trim() };
    return null;
  };

  getStatusText = statusKeyEn => {
    if (statusKeyEn && Message[lang] && Message[lang][statusKeyEn]) {
      return Message[lang][statusKeyEn];
    }
    return statusKeyEn || '';
  };

  checkRegistry() {
    this.setState({
      modalProcessing: true,
      showModal: false,
      showRegistryConfirmationModal: false,
      openCaptchaAfterConfirmation: false,
      confirmProcessing: true,
      completed: false,
      registryCheckPassed: false,
      requiresRegistryConfirmation: false
    });

    const bin = numeric(this.state.formData.bin.value);
    const registry = this.state.formData.registry.value;

    const registriesPayload = registry
      .map(r => {
        const tv = this.getTypeValue(r);
        if (!tv) return null;
        return {
          ...tv,
          amount: toFloat(String(r.amount))
        };
      })
      .filter(Boolean);

    const checkSnapshot = JSON.stringify({
      bin,
      registries: registriesPayload
    });

    http({
      method: 'post',
      url: '/registry/check',
      headers: { 'Keep-Alive': 'timeout=30' },
      data: {
        bin: bin,
        registries: registriesPayload
      }
    })
      .then(responce => {
        const currentBin = numeric(this.state.formData.bin.value);

        const currentRegistriesPayload = this.state.formData.registry.value
          .map(r => {
            const tv = this.getTypeValue(r);
            if (!tv) return null;

            return {
              ...tv,
              amount: toFloat(String(r.amount))
            };
          })
          .filter(Boolean);

        const currentSnapshot = JSON.stringify({
          bin: currentBin,
          registries: currentRegistriesPayload
        });

        if (currentSnapshot !== checkSnapshot) {
          this.setState({
            confirmProcessing: false,
            modalProcessing: false,
            registryCheckPassed: false
          });
          return;
        }
        const { data } = responce;

        const isNewFormat =
          data && data.registries && Array.isArray(data.registries);
        const isOldFormat =
          data && !isNewFormat && typeof data === 'object';

        if (!data || (!isNewFormat && !isOldFormat)) {
          this.setState({
            confirmProcessing: false,
            error: Message[lang].service_not_available,
            modalProcessing: false
          });
          Scroll.animateScroll.scrollToTop();
          return;
        }

        let newRegistry = [];

        if (isNewFormat) {
          const statusMap = {};

          data.registries.forEach(item => {
            const type = String(item?.type || '').toLowerCase();
            const value = String(item?.value ?? '').trim();

            const statusObj = item?.status || {};
            const statusKeyEn = Object.keys(statusObj)[0] || '';

            statusMap[`${type}|${value}`] = statusKeyEn;
          });

          newRegistry = registry.map(r => {
            const tv = this.getTypeValue(r);

            const key = tv
              ? `${tv.type}|${String(tv.value).trim()}`
              : '';

            const statusKeyEn = statusMap[key] || '';

            return {
              ...r,
              statusKey: statusKeyEn,
              status: this.getStatusText(statusKeyEn),
              applyStyle:
                statusKeyEn === 'AVAILABLE_FOR_PAYMENT'
                  ? 'success'
                  : 'error'
            };
          });
        } else {
          newRegistry = registry.map(r => {
            const hasMsisdn = !!r.msisdn;
            const statusKeyEn = hasMsisdn
              ? data[numeric(r.msisdn)] || ''
              : '';

            return {
              ...r,
              statusKey: statusKeyEn,
              status: this.getStatusText(statusKeyEn),
              applyStyle:
                statusKeyEn === 'AVAILABLE_FOR_PAYMENT'
                  ? 'success'
                  : 'error'
            };
          });
        }

        const allOk =
          newRegistry.length > 0 &&
          newRegistry.every(r =>
            permittedStatuses.includes(r.statusKey)
          );

        const requiresRegistryConfirmation = newRegistry.some(r =>
          confirmationStatuses.includes(r.statusKey)
        );
        this.setFormData({
          registry: {
            ...this.state.formData.registry,
            value: newRegistry,
            error: allOk ? null : Message[lang].table_contains_error
          }
        });

        if (allOk) {
          this.recaptchaWidgetId = undefined;
          this.setState(
            {
              confirmProcessing: false,
              modalProcessing: false,
              showModal: !requiresRegistryConfirmation,
              showRegistryConfirmationModal: requiresRegistryConfirmation,
              captchaToken: null,
              captchaError: null,
              registryCheckPassed: true,
              requiresRegistryConfirmation,
              error: null
            },
            () => {
              if (
                !requiresRegistryConfirmation &&
                window.grecaptcha &&
                typeof window.grecaptcha.ready === 'function'
              ) {
                window.grecaptcha.ready(() => {
                  this.renderRecaptcha();
                });
              }
            }
          );
        } else {
          this.setState({
            confirmProcessing: false,
            error: Message[lang].table_contains_error,
            modalProcessing: false
          });
          Scroll.animateScroll.scrollToTop();
        }
      })

      .catch(() => {
        this.setState({
          confirmProcessing: false,
          error: Message[lang].service_not_available,
          modalProcessing: false
        });
        Scroll.animateScroll.scrollToTop();
      });
  }

  submitApplication = () => {
    const { captchaToken, registryCheckPassed } = this.state;

    if (!registryCheckPassed) {
      return;
    }

    if (!captchaToken) {
      this.setState({
        captchaError: 'Подтвердите, что вы не робот'
      });
      return;
    }

    this.sendEregistry();
  };

  confirmRegistry = () => {
    this.setState({
      showRegistryConfirmationModal: false,
      openCaptchaAfterConfirmation: true
    });
  };

  closeRegistryConfirmationModal = () => {
    this.setState(prev => ({
      showRegistryConfirmationModal: false,
      openCaptchaAfterConfirmation: false,
      registryCheckPassed: false,
      requiresRegistryConfirmation: false,
      error: Message[lang].table_contains_error,
      formData: {
        ...prev.formData,
        registry: {
          ...prev.formData.registry,
          error: Message[lang].table_contains_error
        }
      }
    }));
  };

  handleRegistryConfirmationExited = () => {
    if (!this.state.openCaptchaAfterConfirmation) {
      return;
    }

    this.recaptchaWidgetId = undefined;

    this.setState({
      openCaptchaAfterConfirmation: false,
      showModal: true,
      captchaToken: null,
      captchaError: null
    });
  };

  closeCaptchaModal = () => {
    const recaptchaApi = window.grecaptcha || null;

    if (
      recaptchaApi &&
      typeof recaptchaApi.reset === 'function' &&
      this.recaptchaWidgetId !== undefined
    ) {
      recaptchaApi.reset(this.recaptchaWidgetId);
    }

    this.setState({
      showModal: false,
      confirmProcessing: false,
      modalProcessing: false,
      token: null,
      captchaToken: null,
      captchaError: null,
      registryCheckPassed: false,
      requiresRegistryConfirmation: false
    });
  };

  drawDialog(lang) {
    return (
      <Modal
        show={this.state.showModal}
        onHide={this.closeCaptchaModal}
        onEntered={() => this.renderRecaptcha()}
        container={this}
        dialogClassName="e-registry-confirm-modal"
        aria-labelledby="contained-modal-title"
      >
        <Modal.Body>
          {Message[lang].e_registry_send_warning}

          <div style={{ marginTop: '15px' }}>
            <div id="recaptcha-container" />
          </div>

          {this.state.captchaError && (
            <div
              style={{
                color: 'red',
                fontSize: '12px',
                marginTop: '5px'
              }}
            >
              {this.state.captchaError}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={
              !this.state.modalProcessing
                ? () => {
                    this.submitApplication();
                  }
                : null
            }
            disabled={
              this.state.modalProcessing || !this.state.captchaToken
            }
            className="btn btn-primary"
            style={{
              opacity:
                this.state.modalProcessing || !this.state.captchaToken
                  ? 0.5
                  : 1,
              pointerEvents:
                this.state.modalProcessing || !this.state.captchaToken
                  ? 'none'
                  : 'auto'
            }}
          >
            {Message[lang].send_e_registry}
          </Button>
          <Button onClick={this.closeCaptchaModal}>
            {Message[lang].no}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  drawErrorView(field) {
    return field.error ? (
      <label
        style={{
          color: 'red',
          fontSize: '12px'
        }}
      >
        {field.error}
      </label>
    ) : (
      ''
    );
  }

  setEdit(fieldName) {
    this.setState(prev => ({
      formData: {
        ...prev.formData,
        [fieldName]: {
          ...prev.formData[fieldName],
          isEdit: !prev.formData[fieldName].isEdit
        }
      }
    }));
  }

  drawBinView(lang) {
    const { bin } = this.state.formData;
    const { paymentDocument } = this.state;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';

    return (
      <div
        className="input-item col-xs-12 col-md-6"
        style={{ minHeight: '80px' }}
      >
        <label>
          {Message[lang].corp_bin}
          {isEditView && (
            <img
              alt="edit-icon"
              className="e-registry-input-icon"
              src={bin.isEdit ? doneIcon : editIcon}
              onClick={() => this.setEdit('bin')}
            />
          )}
        </label>
        <MaskedInput
          className="form-control input-group"
          ref="bin"
          mask="111 111 111 111"
          type="text"
          value={bin.value}
          disabled={!bin.isEdit}
          onChange={s => {
            const value = s.target.value;

            this.setState(prev => ({
              formData: {
                ...prev.formData,
                bin: {
                  ...prev.formData.bin,
                  value: value,
                  error: null
                }
              },
              registryCheckPassed: false,
              requiresRegistryConfirmation: false,
              showRegistryConfirmationModal: false,
              openCaptchaAfterConfirmation: false,
              captchaToken: null,
              captchaError: null
            }));
          }}
        />
        {this.drawErrorView(bin)}
      </div>
    );
  }

  drawCompanyNameView(lang) {
    const { name } = this.state.formData;
    const { paymentDocument } = this.state;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';
    return (
      <div
        className="input-item col-xs-12 col-md-6"
        style={{ minHeight: '80px' }}
      >
        <label>
          {Message[lang].corp_name}
          {isEditView && (
            <img
              alt="edit-icon"
              className="e-registry-input-icon"
              src={name.isEdit ? doneIcon : editIcon}
              onClick={() => this.setEdit('name')}
            />
          )}
        </label>
        <input
          type="text"
          className="form-control input-group"
          name="registry.companyName"
          value={name.value}
          disabled={!name.isEdit}
          onChange={s =>
            this.setFormData({
              name: {
                ...name,
                value: s.target.value,
                error: null
              }
            })
          }
        />
        {this.drawErrorView(name)}
      </div>
    );
  }

  drawCompanyPhoneView(lang) {
    const { phone } = this.state.formData;
    return (
      <div className="input-item col-xs-12 col-md-6">
        <label>{Message[lang].corp_phone}</label>
        <MaskedInput
          className="form-control input-group"
          mask="+7 111 111 11 11"
          name="phone"
          type="text"
          value={phone.value}
          onChange={s =>
            this.setFormData({
              phone: {
                ...phone,
                value: s.target.value,
                error: null
              }
            })
          }
        />
        {this.drawErrorView(phone)}
      </div>
    );
  }

  drawEmailView(lang) {
    const { email } = this.state.formData;
    return (
      <div className="input-item col-xs-12 col-md-6">
        <label>{Message[lang].settings_email}</label>
        <input
          type="text"
          className="form-control input-group"
          name="registry.email"
          placeholder="example@domain.com"
          value={email.value}
          onChange={s =>
            this.setFormData({
              email: {
                ...email,
                value: s.target.value,
                error: null
              }
            })
          }
        />
        {this.drawErrorView(email)}
      </div>
    );
  }

  drawPaymentDateView(lang) {
    const { paymentDate } = this.state.formData;
    const { paymentDocument } = this.state;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';
    const isDisabled = !paymentDate.isEdit;

    return (
      <div className="input-item col-xs-12 col-md-6">
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <label>
            {Message[lang].payment_date}
            {isEditView && (
              <img
                alt="edit-icon"
                className="e-registry-input-icon"
                src={paymentDate.isEdit ? doneIcon : editIcon}
                onClick={() => this.setEdit('paymentDate')}
              />
            )}
          </label>
          <div
            className="e-registry-info-root"
            style={{ marginLeft: 5 }}
          >
            <img
              src={infoIcon}
              alt="info-icon"
              className="e-registry-info-icon"
            />
            <div className="e-registry-info-text">
              {Message[lang].payment_date_info}
            </div>
          </div>
        </div>
        <div
          className={`data-time-field-wrapper ${
            isDisabled ? 'disabled' : ''
          }`}
        >
          <DateTimeField
            format={'YYYY-MM-DD'}
            viewMode={'date'}
            mode={'date'}
            disabled={isDisabled}
            dateTime={
              paymentDate.value
                ? paymentDate.value
                : moment().format('YYYY-MM-DD')
            }
            inputFormat={'YYYY-MM-DD'}
            defaultText={Message[lang].please_select_date}
            input={false}
            onChange={value =>
              this.setFormData({
                paymentDate: {
                  ...paymentDate,
                  value: value,
                  error: null
                }
              })
            }
          />
        </div>
        {this.drawErrorView(paymentDate)}
      </div>
    );
  }

  drawPaymentNumberView(lang) {
    const { paymentNumber } = this.state.formData;
    const { paymentDocument } = this.state;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';
    return (
      <div className="input-item col-xs-12 col-md-6">
        <label>
          {Message[lang].payment_order_num}
          {isEditView && (
            <img
              alt="edit-icon"
              className="e-registry-input-icon"
              src={paymentNumber.isEdit ? doneIcon : editIcon}
              onClick={() => this.setEdit('paymentNumber')}
            />
          )}
        </label>
        <input
          type="text"
          value={paymentNumber.value}
          className="form-control input-group"
          disabled={!paymentNumber.isEdit}
          onChange={i =>
            paymentNumRegex.test(i.target.value) &&
            this.setFormData({
              paymentNumber: {
                ...paymentNumber,
                value: i.target.value,
                error: null
              }
            })
          }
        />
        {this.drawErrorView(paymentNumber)}
      </div>
    );
  }

  drawDestBankAccountView(lang) {
    const { bankAccounts, paymentDocument } = this.state;
    const { destinationBankAccount } = this.state.formData;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';
    if (!bankAccounts) {
      return null;
    }
    return (
      <div className="input-item col-xs-12 col-md-6">
        <label>
          {Message[lang].kcell_payment_account}
          {isEditView && (
            <img
              alt="edit-icon"
              src={
                destinationBankAccount.isEdit ? doneIcon : editIcon
              }
              className="e-registry-input-icon"
              onClick={() => this.setEdit('destinationBankAccount')}
            />
          )}
        </label>
        <Select
          value={destinationBankAccount.value}
          disabled={!destinationBankAccount.isEdit}
          placeholder={Message[lang].kcell_payment_account}
          className="input-width"
          clearable={false}
          searchable={false}
          options={bankAccounts.map(b => ({
            value: b.id,
            label: b.label
          }))}
          onChange={s =>
            this.setFormData({
              destinationBankAccount: {
                ...destinationBankAccount,
                value: s,
                error: null
              }
            })
          }
        />
        {this.drawErrorView(destinationBankAccount)}
      </div>
    );
  }

  drawPaymentSumView(lang) {
    const { paymentSum } = this.state.formData;
    const { paymentDocument } = this.state;
    const isEditView =
      paymentDocument.tries <= 1 ||
      paymentDocument.status === 'success';
    const handleClose = () => {
      this.setState(prev => ({
        formData: {
          ...prev.formData,
          paymentSum: {
            ...prev.formData.paymentSum,
            isModalError: false
          }
        }
      }));
    };
    return (
      <div className="input-item col-xs-12 col-md-6">
        <label>
          {Message[lang].payment_sum}
          {isEditView && (
            <img
              alt="edit-icon"
              className="e-registry-input-icon"
              src={paymentSum.isEdit ? doneIcon : editIcon}
              onClick={() => this.setEdit('paymentSum')}
            />
          )}
        </label>
        <input
          type="text"
          value={paymentSum.value}
          className="form-control input-group"
          disabled={!paymentSum.isEdit}
          onChange={i =>
            realNumRegex.test(i.target.value) &&
            this.setFormData({
              paymentSum: {
                ...paymentSum,
                value: i.target.value,
                error: null
              }
            })
          }
        />
        {paymentSum.isModalError && (
          <ERegistryModal
            isOpen={paymentSum.isModalError}
            text={Message[lang].paymentSum_error}
            handleClose={handleClose}
            onClick={handleClose}
            lang={lang}
            withReject={false}
            instance={this}
          />
        )}
        {this.drawErrorView(paymentSum)}
      </div>
    );
  }

  validateResponse(obj) {
    for (const key in obj) {
      const isErr =
        (typeof obj[key] !== 'number' && !obj[key]) ||
        obj[key] === null ||
        obj[key] === 'null';
      if (isErr) {
        return false;
      }
    }
    return true;
  }

  onSuccessRecognition(data) {
    const isValid = this.validateResponse(data);
    this.setState(prev => {
      let paymentDoc;
      if (isValid) {
        paymentDoc = {
          status: 'success',
          isModalOpen: true
        };
      } else {
        paymentDoc = {
          status: 'error',
          isModalOpen: true,
          tries: prev.paymentDocument.tries - 1
        };
      }
      return {
        ...prev,
        paymentDocument: {
          ...prev.paymentDocument,
          ...paymentDoc
        },
        recognitionData: data,
        registryCheckPassed: false,
        captchaToken: null,
        captchaError: null,
        formData: {
          ...prev.formData,
          bin: {
            ...prev.formData.bin,
            value: data.bin ?? '',
            error: null
          },
          paymentDate: {
            ...prev.formData.paymentDate,
            value: data.paymentDate ?? '',
            error: null
          },
          destinationBankAccount: {
            ...prev.formData.destinationBankAccount,
            value:
              this.state.bankAccounts.find(
                acc => acc.account === data.kcellAccount
              )?.id ?? null,
            error: null
          },
          name: {
            ...prev.formData.name,
            value: data.companyName ?? '',
            error: null
          },
          paymentNumber: {
            ...prev.formData.paymentNumber,
            value: data.paymentNumber ?? '',
            error: null
          },
          paymentSum: {
            ...prev.formData.paymentSum,
            value: data.paymentSum ?? '',
            error: null
          }
        }
      };
    });
  }

  onErrorRecognition() {
    this.setState(prev => {
      return {
        ...prev,
        paymentDocument: {
          ...prev.paymentDocument,
          status: 'error',
          isModalOpen: true,
          tries: prev.paymentDocument.tries - 1
        }
      };
    });
  }

  uploadFile(file) {
    this.setState(prev => {
      return {
        paymentDocument: { ...prev.paymentDocument, isLoading: true },
        formData: {
          ...prev.formData,
          file: { ...prev.formData.file, value: null, fileName: '' }
        }
      };
    });
    const formData = new FormData();
    formData.append('file', file);
    BankServices.uploadFileRecognition(formData)
      .then(({ id }) => {
        this.setState(prev => ({
          ...prev,
          recognition: { ...prev?.recognition, id, isModalOpen: true }
        }));
      })
      .catch(() => {
        this.setState(prev => {
          return {
            ...prev,
            paymentDocument: {
              ...prev.paymentDocument,
              status: 'error',
              isModalOpen: true,
              tries: prev.paymentDocument.tries - 1
            }
          };
        });
      })
      .finally(() => {
        this.setState(prev => {
          return {
            ...prev,
            paymentDocument: {
              ...prev.paymentDocument,
              isLoading: false
            },
            formData: {
              ...prev.formData,
              file: {
                ...prev.formData.file,
                value: file,
                fileName: file.name
              }
            }
          };
        });
      });
  }

  drawFileUpload(lang) {
    const { file } = this.state.formData;
    const {
      isModalOpen: isRecognitionOpen,
      id: recognitionId
    } = this.state.recognition;
    const {
      isLoading,
      status,
      tries,
      isModalOpen
    } = this.state.paymentDocument;
    const handleClose = () => {
      this.setState(prev => ({
        paymentDocument: {
          ...prev.paymentDocument,
          isModalOpen: false
        }
      }));
    };
    const handleCloseRecognition = () => {
      this.setState(prev => ({
        ...prev,
        recognition: {
          ...prev?.recognition,
          isModalOpen: false,
          id: ''
        }
      }));
    };

    const getModalText = (status, tries) => {
      if (status === 'error') {
        switch (tries) {
          case 2:
            return Message[lang].upload_doc_error_message2;
          case 1:
            return Message[lang].upload_doc_error_message1;
          default:
            return Message[lang].upload_doc_error_message3;
        }
      } else {
        return Message[lang].upload_doc_success_message;
      }
    };

    return (
      <div className="col-xs-12">
        <label
          className="btn btn-primary"
          style={{
            minWidth: 291,
            maxHeight: 41,
            cursor: 'pointer'
          }}
        >
          {isLoading
            ? Message[lang].loading
            : Message[lang].choose_file}
          <input
            disabled={isLoading || tries <= 0}
            type="file"
            accept="application/pdf"
            style={{ display: 'none' }}
            onChange={e => {
              if (e.target.files[0].size > 5000000) {
                alert(Message[lang].file_is_large);
                return;
              }
              const fileName = e.target.files[0]?.name?.toLowerCase();
              if (fileName && fileName.includes('.pdf')) {
                this.uploadFile(e.target.files[0]);
              } else {
                alert(Message[lang].invalid_file_format);
              }
              e.target.value = '';
            }}
          />
        </label>
        <div
          className="e-registry-info-root"
          style={{ marginLeft: 5 }}
        >
          <img
            src={infoIcon}
            alt="info-icon"
            className="e-registry-info-icon"
          />
          <div className="e-registry-info-text">
            {Message[lang].payment_details_warn}
            {Message[lang].payment_details_info}
          </div>
        </div>
        {['error', 'success'].includes(status) && (
          <ERegistryModal
            isOpen={isModalOpen}
            text={getModalText(status, tries)}
            handleClose={handleClose}
            onClick={handleClose}
            lang={lang}
            withReject={false}
            instance={this}
          />
        )}
        {recognitionId && (
          <RecognitionModal
            key={recognitionId}
            isOpen={isRecognitionOpen}
            onSuccess={this.onSuccessRecognition.bind(this)}
            onError={this.onErrorRecognition.bind(this)}
            lang={lang}
            instance={this}
            handleClose={handleCloseRecognition}
            id={recognitionId}
          />
        )}
        {file?.fileName && (
          <p className="text-grey-tint">{file?.fileName}</p>
        )}
        {this.drawErrorView(file)}
        <h6 className="small text-rich-purple">
          {Message[lang].e_registry_upload_warning}
        </h6>
      </div>
    );
  }

  render() {
    const { confirmProcessing, error, completed } = this.state;
    const { registry } = this.state.formData;
    const instructionLink = getEregistryInstructionLink(lang);
    const videoLink = getEregistryVideoLink(lang);

    return (
      <div>
        <header className="header">
          <div className="logo">
            <img src={logo} alt="Kcell logo" />
          </div>

          <div className="lang-select">
            <LangSelect
              value={lang}
              onChange={val => setLangItem(val)}
            />
          </div>
        </header>
        <div className="row">
          <section className="title-section">
            <div className="container-fluid">
              <div className="subpage-title-module">
                <h1>{Message[lang].eregister}</h1>
                <div className="service-description">
                  <p>{Message[lang].eregister_desc}</p>
                  <div className="service-bold-description">
                    {Message[lang].if_num_is_saved}
                    <br />
                    {Message[lang].registry_saved}
                  </div>
                  <div className="service-red-bold-description">
                    {Message[lang].re_registration_number}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>

        <div name="alert">
          <div
            className="col-xs-12 alert alert-success"
            style={completed ? {} : { display: 'none' }}
          >
            {Message[lang].register_send_success}
          </div>

          {error && (
            <div className="col-xs-12 alert alert-danger">
              {error}
            </div>
          )}
        </div>

        <div
          className="e-registry row"
          style={completed ? { display: 'none' } : {}}
        >
          <div className="content-part col-xs-12">
            <p className="small-text">
              <a
                target="_blank"
                rel="noopener noreferrer"
                href={videoLink}
              >
                {Message[lang].eregistry_video_instruction}
              </a>
              <br />

              <a
                target="_blank"
                rel="noopener noreferrer"
                href={instructionLink}
              >
                {Message[lang].download_eregitry_instruction}
              </a>
              <br />

              <a href="https://static.kcell.kz/files/kcell/docs/eregistry_example_new.csv">
                {Message[lang].download_eregitry_example}
              </a>
            </p>
            <br />

            <div className="alert alert-warning">
              {Message[lang].eregistry_warning}
            </div>
            <div>
              <h4 className="step">
                <span>1</span>
                &nbsp;{Message[lang].contacts_data}
              </h4>
              <div className="step-content">
                <p className="text-grey-tint">
                  {Message[lang].enter_feedback_details}
                </p>
                <div
                  className="form-group"
                  style={{ marginLeft: '-14px' }}
                >
                  {this.drawCompanyPhoneView(lang)}
                  {this.drawEmailView(lang)}
                </div>
              </div>

              <h4 className="step">
                <span>2</span>
                &nbsp;{Message[lang].payment_details}
              </h4>
              <div className="step-content">
                <div
                  className="form-group"
                  style={{ marginLeft: '-14px' }}
                >
                  {this.drawFileUpload(lang)}
                </div>
                <div
                  className="form-group"
                  style={{ marginLeft: '-14px' }}
                >
                  {this.drawBinView(lang)}
                  {this.drawCompanyNameView(lang)}
                </div>
                <div
                  className="form-group"
                  style={{ marginLeft: '-14px' }}
                >
                  {this.drawPaymentDateView(lang)}
                  {this.drawPaymentNumberView(lang)}
                </div>
                <div
                  className="form-group"
                  style={{ marginLeft: '-15px' }}
                >
                  {this.drawDestBankAccountView(lang)}
                  {this.drawPaymentSumView(lang)}
                </div>
              </div>
              <h4 className="step">
                <span>3</span>
                &nbsp;{Message[lang].numbers}
              </h4>
              <div className="step-content">
                <p className="text-grey-tint">
                  {Message[lang].e_registry_numbers_desc}{' '}
                  <a href="https://static.kcell.kz/files/kcell/docs/eregistry_example_new.csv">
                    {Message[lang].new_erp_registry_template_link}
                  </a>
                </p>
                <ERegistryNumbers
                  lang={lang}
                  data={registry.value}
                  onDataChange={(data, error) =>
                    this.onRegistryChange(data, error)
                  }
                />
                {this.drawErrorView(registry)}
              </div>

              <div
                className="step-content"
                style={{ marginLeft: '-14px' }}
              >
                <div className="col-xs-6">
                  <button
                    className="btn btn-primary"
                    onClick={() => this.validateForm()}
                    disabled={confirmProcessing}
                  >
                    {(confirmProcessing && <Spinner />) ||
                      Message[lang].check_e_registry}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          show={this.state.showSapHanaMigrationModal}
          onHide={() =>
            this.setState({
              showSapHanaMigrationModal: false,
              showNewErpRegistryModal: true
            })
          }
          container={this}
          dialogClassName="sap-hana-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{Message[lang].attention}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div style={{ whiteSpace: 'pre-line' }}>
              {Message[lang].sap_hana_migration_notice}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({
                  showSapHanaMigrationModal: false,
                  showNewErpRegistryModal: true
                })
              }
              className="btn btn-primary"
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showNewErpRegistryModal}
          onHide={() =>
            this.setState({ showNewErpRegistryModal: false })
          }
          container={this}
          dialogClassName="sap-hana-modal"
        >
          <Modal.Header closeButton>
            <Modal.Title>{Message[lang].attention}</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <div>
              <p>{Message[lang].new_erp_registry_notice_intro}</p>

              <p>{Message[lang].new_erp_registry_notice_params}</p>

              <p>
                {Message[lang].new_erp_registry_notice_template}{' '}
                <a href="https://static.kcell.kz/files/kcell/docs/eregistry_example_new.csv">
                  {Message[lang].new_erp_registry_template_link}
                </a>
              </p>

              <p>
                {Message[lang].new_erp_registry_notice_instruction}{' '}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={instructionLink}
                >
                  {Message[lang].new_erp_registry_instruction_link}
                </a>
              </p>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              onClick={() =>
                this.setState({ showNewErpRegistryModal: false })
              }
              className="btn btn-primary"
            >
              OK
            </Button>
          </Modal.Footer>
        </Modal>

        <Modal
          show={this.state.showRegistryConfirmationModal}
          onHide={this.closeRegistryConfirmationModal}
          onExited={this.handleRegistryConfirmationExited}
          container={this}
          dialogClassName="e-registry-confirm-modal"
        >
          <Modal.Body>
            {Message[lang].registry_bin_confirmation}
          </Modal.Body>

          <Modal.Footer>
            <Button
              className="btn btn-primary"
              onClick={this.confirmRegistry}
            >
              {Message[lang].yes}
            </Button>

            <Button onClick={this.closeRegistryConfirmationModal}>
              {Message[lang].no}
            </Button>
          </Modal.Footer>
        </Modal>

        {this.drawDialog(lang)}
      </div>
    );
  }
}

export default ERegistry;
